import { Record } from 'immutable';

export default class AssistedLivingRecord extends Record({
  id: undefined,
  ahcaNumber: '',
  licenseNumber: '',
  facilityType: '',
  facilityName: '',
  physicalAddress: '',
  physicalCity: '',
  physicalState: '',
  physicalZip: '',
  physicalCounty: '',
  phone: '',
  mailingAddress: '',
  mailingCity: '',
  mailingState: '',
  mailingZip: '',
  mailingCounty: '',
  licenseStatus: '',
  owner: '',
  adminCEO: '',
  licensedBeds: '',
  profitStatus: '',
  url: '',
  latitude: '',
  longitude: '',
  lastUpdated: ''
}) {}



// WEBPACK FOOTER //
// ./src/records/AssistedLiving.js